import { MediaBlockProps } from '../../types'

// Video can run to the page's edges, as images can. Audio stays in the text
// column: its controls would sit against the page's edge.
export const mediaSupportsFullWidth = (props: Pick<MediaBlockProps, 'kind'>) =>
  props.kind === 'video'
